import React from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import axios from 'axios';
import { useQuery } from '@panel/commons/hooks';
import { site } from '@panel/commons/helpers';
import BannerBrasil from './banners/brasil';

const siteId = site.id;

function SuccessPublishBanner() {
  const [postingId] = useQuery(useLocation(), ['postingId']);
  const { t } = useTranslation();
  const dataToBenvi = {
    postingId
  };

  const sendDataToBenvi = async (data, openPage) => {
    const headers = {
      'Content-Type': 'application/json',
      'Access-Control-Allow-Origin': window.location.origin,
      'x-panel-portal': siteId,
      'X-NAVENT-APP': 'publicador'
    };
    try {
      await axios.post(`${process.env.REACT_APP_API_ECOMMERCE}/ecommerce/api/v1/subscription/${postingId}`, data, {
        headers
      });
    } catch (err) {
      // eslint-disable-next-line no-console
      console.error('Unable to send data:', err);
    }
    window.open(t('publisher.stepStatus.success.banner.link.CTA'), openPage).focus();
  };

  const onClickHandler = openPage => {
    sendDataToBenvi(dataToBenvi, openPage);
  };

  return <BannerBrasil handleClick={() => onClickHandler('_blank')} />;
}

export { SuccessPublishBanner };
